import React from "react";
import { createPortal } from "react-dom";
import defaultMascot from "../../../../assets/AIcontainer.png";
import exitChatMascot from "../../../../assets/exitchat2.png";


const ExitScreen = ({
  onStay,
  onExit,
  onComplete,
  subsectionUrl,
}) => {
  // Determine mascot based on agent type
  const getMascot = () => {
    switch(subsectionUrl) {
      case "unfairness_agent":
      case "visibility_agent":
        return exitChatMascot;
      default:
        return defaultMascot;
    }
  };


  const mascot = getMascot();


  return createPortal(
    (
      <div
        className="fixed inset-0 z-[9999] flex items-center justify-center"
        style={{
          background: "#1D1D1DF2",
          backdropFilter: "blur(16px)"
        }}
      >
        {/* Dialog Box - ✅ REDUCED SIZE */}
        <div
          className="flex flex-col items-center relative"
          style={{
            width: 450,  // ✅ REDUCED from 530 to 450
            height: 440,  // ✅ REDUCED from 523 to 440
            borderRadius: 16,
            background: "#fff",
            top: 0,
            left: 0,
            boxShadow: "0 3px 24px rgba(0,0,0,0.12)"
          }}
        >
          {/* Mascot - ✅ SCALED DOWN */}
          <img
            src={mascot}
            alt="Mascot"
            style={{
              position: "absolute",
              top: -135,  // ✅ ADJUSTED from -149
              left: "calc(50% - 110px)",  // ✅ ADJUSTED from -140px
              width: 240,  // ✅ REDUCED from 279.62
              height: 300,  // ✅ REDUCED from 353.41
              objectFit: "contain",
              zIndex: 2,
              pointerEvents: "none",
              opacity: 1
            }}
          />


          {/* Main Box Content */}
          <div className="flex flex-col mt-[165px] w-full items-center px-8 gap-2">
            {/* Headline - ✅ REDUCED FONT */}
            <div
              className="font-gotham"
              style={{
                fontSize: 20,  // ✅ REDUCED from 24
                fontWeight: 500,  // ✅ NOT BOLD
                color: "#323232",
                lineHeight: "30px",
                textAlign: "center"
              }}
            >
              Leaving now?
            </div>


            {/* Subheading - ✅ REDUCED FONT */}
            <div
              className="font-gotham"
              style={{
                fontSize: 16,  // ✅ REDUCED from 18
                fontWeight: 400,  // ✅ NOT BOLD (was 500)
                color: "#666666",
                textAlign: "center",
                lineHeight: "135%",
                marginTop: 4,
                marginBottom: 20
              }}
            >
              What if your next insight was just one tap away?
            </div>


            {/* Buttons Row - ✅ REDUCED SIZE */}
            <div className="w-full flex flex-row justify-center gap-3 mb-3">
              <button
                onClick={onStay}
                className="transition-all duration-200 font-gotham hover:opacity-90"
                style={{
                  width: 180,  // ✅ REDUCED from 217
                  height: 56,  // ✅ REDUCED from 69
                  background: "#54B0AF",
                  color: "#ffffff",
                  borderRadius: 16,  // ✅ REDUCED from 20
                  fontSize: 18,  // ✅ REDUCED from 21
                  fontWeight: 500,  // ✅ NOT BOLD
                  padding: "18px 16px",
                  lineHeight: "100%",
                  letterSpacing: 0,
                  textAlign: "center"
                }}
              >
                Stay & Analyse
              </button>
              <button
                onClick={onExit}
                className="transition-all duration-200 font-gotham hover:opacity-80"
                style={{
                  width: 180,  // ✅ REDUCED from 215
                  height: 56,  // ✅ REDUCED from 69
                  background: "#E3E3E3",
                  color: "#666666",
                  borderRadius: 16,  // ✅ REDUCED from 20
                  fontSize: 18,  // ✅ REDUCED from 21
                  fontWeight: 500,  // ✅ NOT BOLD
                  padding: "18px 16px",
                  lineHeight: "100%",
                  letterSpacing: 0,
                  textAlign: "center"
                }}
              >
                I'll be back later
              </button>
            </div>


            {/* Mark as Complete Button - ✅ REDUCED SIZE */}
            <button
              onClick={onComplete}
              className="font-gotham transition-all duration-200 hover:opacity-90"
              style={{
                width: 380,  // ✅ REDUCED from 452
                height: 56,  // ✅ REDUCED from 69
                background: "#000",
                color: "#ffffff",
                borderRadius: 16,  // ✅ REDUCED from 20
                fontSize: 18,  // ✅ REDUCED from 21
                fontWeight: 500,  // ✅ NOT BOLD
                padding: "18px 16px",
                lineHeight: "100%",
                letterSpacing: 0,
                textAlign: "center"
              }}
            >
              Exit & Mark as Complete
            </button>
          </div>
        </div>
      </div>
    ),
    document.body
  );
};


export default ExitScreen;

